module.exports = __webpack_public_path__ + "img/registration success_ENg.9c09fd8c.png";